<template>
  <v-row no-gutters>
    <!-- <v-col cols="12">
      <p class="borderLight--text text-caption">No data available. Please add readings for gas analysis.</p>
    </v-col> -->
    <v-col cols="12" class="my-4">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-file-input
            class="mt-0"
            v-model="files"
            hide-input
            color="primary"
            dense
            @change="view"
            @click:clear="clear_file"
            accept=".csv"
            placeholder="Upload the CSV File"
            label="File input"
            prepend-icon="mdi-cloud-upload"
          >
          </v-file-input
        ></v-col>
        <v-col cols="auto">
          <v-btn
            v-if="!is_editable"
            @click="
              is_editable = true;
              show_duval = false;
            "
            outlined
            class="mr-4"
            small
          >
            <v-icon left> mdi-pencil </v-icon>
            Add Sample
          </v-btn>
        </v-col></v-row
      >
    </v-col>
    <v-col cols="12" class="mb-8" v-if="is_editable">
      <v-form ref="form" v-model="valid" lazy-validation>
        <table class="table table-borderless">
          <thead class="v-data-table-header">
            <tr>
              <!-- <th colspan="1"></th> -->
              <th colspan="6" class="border-td">Required(*)</th>
              <th colspan="4">Optional</th>
            </tr>
            <tr>
              <!-- <th><v-checkbox hide-details dense></v-checkbox></th> -->
              <!-- <th>ID</th> -->
              <th>
                <div>Date*</div>
                (yyyy-mm-dd)
              </th>
              <th>
                <div>H2*</div>
                (ppm)
              </th>
              <th>
                <div>CH4*</div>
                (ppm)
              </th>
              <th>
                <div>C2H4*</div>
                (ppm)
              </th>
              <th>
                <div>C2H6*</div>
                (ppm)
              </th>
              <th>
                <div>C2H2*</div>
                (ppm)
              </th>
              <th>
                <div>CO</div>
                (ppm)
              </th>
              <th>
                <div>CO2</div>
                (ppm)
              </th>
              <th>
                <div>O2</div>
                (ppm)
              </th>
              <th>
                <div>N2</div>
                (ppm)
              </th>
              <th></th>
            </tr>
          </thead>
          <tr v-for="(item, index) in gas_analysis_data" :key="`gas_analysis_row${item.date}${index}`">
            <!-- <td><v-checkbox hide-details dense></v-checkbox></td> -->
            <!-- <td>{{ index + 1 }}</td> -->
            <td>
              <v-menu
                v-model="date_menu[index]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details
                    v-model="item.date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                    :rules="requiredRule"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="item.date" @input="date_menu[index] = false"></v-date-picker>
              </v-menu>
            </td>
            <td>
              <v-text-field
                hide-details
                type="number"
                :rules="requiredRule"
                dense
                outlined
                v-model="item.h2"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                hide-details
                type="number"
                :rules="requiredRule"
                dense
                outlined
                v-model="item.ch4"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                hide-details
                type="number"
                :rules="requiredRule"
                dense
                outlined
                v-model="item.c2h4"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                hide-details
                type="number"
                :rules="requiredRule"
                dense
                outlined
                v-model="item.c2h6"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                hide-details
                type="number"
                :rules="requiredRule"
                dense
                outlined
                v-model="item.c2h2"
              ></v-text-field>
            </td>
            <td><v-text-field hide-details type="number" dense outlined v-model="item.co"></v-text-field></td>
            <td><v-text-field hide-details type="number" dense outlined v-model="item.co2"></v-text-field></td>
            <td><v-text-field hide-details type="number" dense outlined v-model="item.o2"></v-text-field></td>
            <td><v-text-field hide-details type="number" dense outlined v-model="item.n2"></v-text-field></td>
            <td>
              <!-- <v-btn v-if="index != gas_analysis_data.length - 1" @click="delete_row(index)" color="primary" small icon>
              <v-icon small>mdi-delete</v-icon>
            </v-btn> -->
              <v-btn v-if="index == gas_analysis_data.length - 1" @click="add_new_row" color="primary" small icon>
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </td>
          </tr>
        </table>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn @click="validate" :disabled="!valid" class="mr-4" small color="primary">
              {{ $t("common.words.save") }}
            </v-btn>
            <v-btn @click="cancel" class="mr-4" small>
              {{ $t("common.words.cancel") }}
            </v-btn>
          </v-col></v-row
        >
      </v-form>
    </v-col>
    <v-col cols="12" v-else>
      <DataTableVT
        item_key="date"
        :headers="config"
        :items_list="data"
        @action="delete_row($event)"
        :selected_row="selected_row ? selected_row.date : null"
        @trClick="trClick($event)"
      />
    </v-col>
    <v-col v-if="show_duval && duval_data_t1 && duval_data_t4 && duval_data_t5" cols="12" class="pt-2 pl-3 pb-4">
      <v-row no-gutters class="ma-4">
        <v-col cols="12">
          <div class="mb-3 font-weight-black primaryDark--text">
            <span class="primaryOutline--text">{{ `Date: ` }}</span
            >{{ selected_row.date }}
          </div>
        </v-col>
        <v-col cols="6">
          <div class="font-weight-bold secondary--text text-subtitle-2 mt-3 mb-6">Triangle 1</div>
          <DuvalChart
            canvasWidth="600"
            :gasData="duval_data_t1"
            :colors="duval_colors"
            chartType="T1"
            @T1="get_t1_result"
          >
          </DuvalChart>
        </v-col>
        <v-col cols="6" v-if="show_t4">
          <div class="font-weight-bold secondary--text text-subtitle-2 mt-3 mb-6">Triangle 4</div>
          <DuvalChart canvasWidth="600" :gasData="duval_data_t4" :colors="duval_colors" chartType="T4"> </DuvalChart>
        </v-col>
        <v-col cols="6" v-if="show_t5">
          <div class="font-weight-bold secondary--text text-subtitle-2 mt-3 mb-6">Triangle 5</div>
          <DuvalChart canvasWidth="600" :gasData="duval_data_t5" :colors="duval_colors" chartType="T5">
          </DuvalChart> </v-col
      ></v-row>
    </v-col>
    <v-overlay class="layering" :absolute="absolute" :value="overlay">
      <v-card class="pa-3" flat :light="!this.$vuetify.theme.dark" color="backgroundLight">
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-row no-gutters class="ma-4">
          <v-col cols="12">
            <div class="text-h6 titleLight--text">Uploaded data:</div>
            <div class="ma-2">
              <DataTableVT :headers="config" :items_list="csv_data" print="true" />
              <v-row>
                <v-spacer></v-spacer>
                <v-col class="mt-7" cols="auto">
                  <v-btn @click="save_csv_data" class="mr-4" small color="primary">
                    {{ $t("common.words.save") }}
                  </v-btn>
                  <v-btn
                    @click="
                      overlay = false;
                      files = [];
                    "
                    class="mr-4"
                    small
                  >
                    {{ $t("common.words.cancel") }}
                  </v-btn>
                </v-col></v-row
              >
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import DataTableVT from "../components/DataTableVT";
import DuvalChart from "../components/DuvalChart";
import { axios_get, axios_post } from "../services/vt_service";
import { h2 } from "../services/powerdata";
import * as d3 from "d3";

export default {
  name: "GasAnalysis",
  components: { DataTableVT, DuvalChart },
  props: {
    config: Array,
    deviceId: String,
    loading: Boolean,
  },
  data: function () {
    return {
      data: [],
      gas_analysis_data: null,
      date_menu: [],
      is_editable: false,
      valid: false,
      show_duval: false,
      selected_row: null,
      files: [],
      absolute: true,
      csv_data: null,
      overlay: false,
      requiredRule: [(v) => !!v || "This field is required"],
      duval_colors: {
        D1: "rgb(172,236,222)",
        D2: "deepskyblue",
        DT: "lightCyan",
        PD: "black",
        T1: "navajoWhite",
        T2: "tan",
        T3: "peru",
        "T2-H": "DeepSkyBlue",
        "T3-H": "LightPink",
      },
      t1_result: null,
    };
  },
  mounted() {
    //fetch gas analysis from API
    this.fetch_gas_data();
  },
  methods: {
    closeDialog() {
      this.overlay = false;
    },
    add_data_for_analysis: function () {
      this.is_editable = false;
    },
    fetch_gas_data: async function () {
      let response = await axios_get(h2.get_scv_h2_gasdata, { id: this.deviceId });
      this.data = [];
      let last_element = null;
      if (response && response[0]) {
        let dates_array = Object.keys(response[0]);
        this.data = dates_array.map((e, index) => {
          let temp = response[0][e];
          temp["date"] = e;
          if (dates_array.length - 1 == index) last_element = temp;
          return temp;
        });
      }
      this.gas_analysis_data = this.data.length == 0 ? [{}] : JSON.parse(JSON.stringify(this.data));
      last_element && this.trClick(last_element);
    },
    update_gas_data: async function (data) {
      let temp = {};
      data.forEach((elem) => {
        let obj = {
          h2: elem.h2,
          ch4: elem.ch4,
          c2h4: elem.c2h4,
          c2h6: elem.c2h6,
          c2h2: elem.c2h2,
          co: elem.co,
          co2: elem.co2,
          o2: elem.o2,
          n2: elem.n2,
        };
        temp[elem.date] = obj;
      });
      await axios_post(h2.update_scv_h2_gasdata, temp, { id: this.deviceId });
      this.fetch_gas_data();
      this.overlay = false;
    },
    save_csv_data: function () {
      this.update_gas_data(this.csv_data);
    },
    get_t1_result: function (event) {
      this.t1_result = event;
    },
    trClick: function (event) {
      this.show_duval = false;
      this.selected_row = event;
      this.show_duval = event ? true : false;
    },
    add_new_row: function () {
      this.gas_analysis_data.push({});
    },
    delete_row: function (index) {
      this.gas_analysis_data.splice(index, 1);
    },
    view_csv: async function () {
      let self = this;
      const input = this.files;
      const reader = new FileReader();

      reader.onload = function (e) {
        const text = e.target.result;
        const csvData = d3.csvParse(text);
        self.csv_data = csvData;
        self.overlay = !self.overlay;
      };

      reader.readAsText(input);
    },
    clear_file: function () {},
    view: async function () {
      if (this.files && this.files.length != 0) {
        await this.view_csv();
        this.files = [];
        // await this.validate_csv();
      }
    },
    validate: function () {
      if (this.$refs.form.validate()) {
        this.update_gas_data(this.gas_analysis_data);
        this.add_data_for_analysis();
      }
    },
    cancel: function () {
      this.is_editable = false;
      this.gas_analysis_data = this.data.length == 0 ? [{}] : JSON.parse(JSON.stringify(this.data));
    },
  },
  computed: {
    duval_data_t1: function () {
      return this.selected_row
        ? [parseFloat(this.selected_row.ch4), parseFloat(this.selected_row.c2h4), parseFloat(this.selected_row.c2h2)]
        : null;
    },
    duval_data_t4: function () {
      return this.selected_row
        ? [parseFloat(this.selected_row.h2), parseFloat(this.selected_row.ch4), parseFloat(this.selected_row.c2h6)]
        : null;
    },
    duval_data_t5: function () {
      return this.selected_row
        ? [parseFloat(this.selected_row.ch4), parseFloat(this.selected_row.c2h4), parseFloat(this.selected_row.c2h6)]
        : null;
    },
    show_t4: function () {
      // Show if PD, T1, or T2 and not D1 or D2
      let show = this.t1_result ? this.t1_result === "PD" || this.t1_result === "T1" || this.t1_result === "T2" : false;
      return show;
    },
    show_t5: function () {
      //  Show if T2 or T3 and not D1 or D2
      let show = this.t1_result ? this.t1_result === "T2" || this.t1_result === "T3" : false;
      return show;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  thead {
    tr {
      border-bottom: 1px solid var(--v-borderLight-base);
      color: var(--v-borderLight-base);
      // opacity: 0.5;
    }

    tr {
      font-size: 12px;
      line-height: 16px;
      text-align: center;

      th {
        padding-bottom: 0.25rem;
        padding-top: 0.25rem;
      }
    }
  }

  tr {
    font-size: 11px;
    height: 30px;
    line-height: 30px;

    td {
      padding-bottom: 0.5rem;
      padding-top: 0.5rem;
    }
  }

  .v-input {
    font-size: 11px;
  }

  .border-td {
    border-right: 1px solid var(--v-borderLight-base);
    // border-left: 1px solid var(--v-borderLight-base);
  }
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
</style>
